import useAuth from 'Modules/firebase/use-auth';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { GifBox } from '@mui/icons-material';

import BackgroundImage from '@/operator/components/general/BackgroundImage';
import GoBackText from '@/operator/components/general/GoBackText';
import { StyledTwoScreensWrapper } from '@/operator/components/modules/AuthPage/Styles';
import { MessageWithTipMui } from '@/operator/components/modules/AuthPage/setup/MessageWithTipMui';
import { getOperatorApexUrl } from '@/operator/utils/env/urlStrings';
import errorPageImg from '@/operator/public/assets/images/background/ErrorPage.svg';

type AccessDeniedPageProps = {
    logoutOnGoBack?: boolean;
};

function AccessDeniedPage({
    logoutOnGoBack,
}: AccessDeniedPageProps): JSX.Element {
    const { t } = useTranslation();
    const { isAuthenticated, logout } = useAuth();

    const operatorUrl = useMemo(getOperatorApexUrl, []);

    return (
        <StyledTwoScreensWrapper>
            <MessageWithTipMui
                Icon={GifBox}
                headline={t('Sneak.Content.Headline')}
                description={t('Sneak.Content.Description')}
                iconDescription={t('ErrorPage.Content.IconDescription')}
                footerSlot={
                    <div style={{ width: '60%', marginTop: '-40px' }}>
                        <GoBackText
                            value={t('Sneak.Content.BackLink')}
                            onClick={
                                logoutOnGoBack
                                    ? () =>
                                          logout({
                                              logoutParams: {
                                                  returnTo:
                                                      window.location.origin,
                                              },
                                          })
                                    : undefined
                            }
                            externalLink={
                                isAuthenticated ? undefined : operatorUrl
                            }
                        />
                    </div>
                }
                termsFooter={false}
            />
            <BackgroundImage src={errorPageImg} />
        </StyledTwoScreensWrapper>
    );
}

export default AccessDeniedPage;
